import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgElectric = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20.7739 15.0028L17.4787 15.029L19.6232 7L15.125 13.3551L19.0216 17.2783L20.7739 15.0028Z",
		fill: "#F19437"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M21 20.799L11.6539 11.4791L11 12.1329L13.9213 15.0287L12.5091 17.0163L15.569 16.9901L13.3459 24.7053L17.7921 18.9255L20.3462 21.4796L21 20.799Z",
		fill: "#F19437"
	})]
});
export default SvgElectric;
